<template>
  <div class="relative size-[30px]">
    <svg viewBox="0 0 30 30" class="size-full -rotate-90" aria-hidden="true">
      <circle
        cx="15"
        cy="15"
        r="13"
        fill="none"
        stroke="#2d2d2d"
        stroke-opacity="0.1"
        stroke-width="4"
      />
      <circle
        cx="15"
        cy="15"
        r="13"
        fill="none"
        stroke="#00b4e6"
        stroke-width="4"
        stroke-linecap="round"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="circumference * (1 - clamped / 100)"
        class="transition-[stroke-dashoffset] duration-200"
      />
    </svg>
    <span
      class="absolute inset-0 flex items-center justify-center text-[11px] leading-none text-gray-800"
    >
      {{ formatNumber(clamped) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatNumber } from '@/shared/utils/number'

const props = defineProps<{ percentage: number }>()

const circumference = 2 * Math.PI * 13

const clamped = computed(() =>
  Math.min(100, Math.max(0, Math.round(props.percentage)))
)
</script>
